<app-module>
  <div header class="header">
    {{pageTitle | translate}}
  </div>
  <main class="content-container {{page}}">
    <div [innerHtml]="html"></div>
  </main>
</app-module>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/generic-page/generic-page.component.html